import * as React from 'react';
import { withStyles } from 'utils/HOCS/withStyles';

export const SectionDescription = withStyles(
  'p',
  'block max-w-4xl mt-4 leading-normal text-base md:text-lg lg:text-xl text-black-text',
);
